<div class="container">
    <nav aria-label="breadcrumb" class="breadCust">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription</a></li>
            <li class="breadcrumb-item" disabled><a routerLink="/corporate/subscription-feature-assign">Assign Feature</a></li>
            <li class="breadcrumb-item active" aria-current="page">Update Assign Feature</li>
  
        </ol>
    </nav>
  </div>
  
  <div class="container">
    <div class="row">
      <div class="col-md-8">
        <form class="form-horizontal" [formGroup]="editAssignForm">
          <div class="card">
            <div class="card-body">
  
              <div class="form-group" *ngIf="customer_id===0">
                <label for="exampleForm2">Company Name <span class="required">*</span></label>
                <select formControlName="selectedCompany" (change)="loadDropdowns()" [(ngModel)]="selectedCompany" class="form-control formstyle ssss"
                  [ngClass]="{ 'is-invalid': submitted && f.selectedCompany.errors }">
                  <option value="">Select Company Name</option>
                  <ng-container *ngFor="let Obj of getCompanyobj">
                    <option *ngIf="Obj.dbstatus == true" value={{Obj.customer_id}}>
                      {{Obj.customer_company_name}}
                    </option>
                  </ng-container>
                </select>
                <div *ngIf="submitted && f.selectedCompany.errors" class="invalid-feedback">
                  <div *ngIf="f.selectedCompany.errors.required">Company Name is required</div>
                </div>
              </div>
  
                <div class="form-group">
                    <label for="exampleForm2">Subscription <span class="required">*</span></label>
                    <select formControlName="sub_id" class="form-control formstyle ssss"
                       [ngClass]="{ 'is-invalid': submitted && f.sub_id.errors }">
                      <option value="">Select Subscription</option>
                      <ng-container *ngFor="let Obj of subsObj">
                        <option  value={{Obj.id}}>
                          {{Obj.title}}
                        </option>
                      </ng-container>
                    </select>
                    <div *ngIf="submitted && f.sub_id.errors" class="invalid-feedback">
                      <div *ngIf="f.sub_id.errors.required">Subscription is required</div>
                    </div>
                  </div>

              <div class="form-group">
                    <label for="exampleForm2">Feature <span class="required">*</span></label>
                    <select formControlName="feature_id" class="form-control formstyle ssss"
                       [ngClass]="{ 'is-invalid': submitted && f.feature_id.errors }">
                      <option value="">Select Feature</option>
                      <ng-container *ngFor="let Obj of featureObj">
                        <option  value={{Obj.id}}>
                          {{Obj.feature_name}}
                        </option>
                      </ng-container>
                    </select>
                    <div *ngIf="submitted && f.feature_id.errors" class="invalid-feedback">
                      <div *ngIf="f.feature_id.errors.required">Feature is required</div>
                    </div>
              </div>
              <div class="form-group">
                <label for="name">Feature Value <span class="required">*</span></label>
                <input type="text" class="form-control" name="feature_value" formControlName="feature_value"
                  [ngClass]="{ 'is-invalid': submitted && f.feature_value.errors }" maxlength="100" placeholder="true / false / 2GB / Unlimited">
                <div *ngIf="submitted && f.feature_value.errors" class="invalid-feedback">
                  <div *ngIf="f.feature_value.errors.required">Feature Value is required</div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="text-center">
                <button class="btn btn-round btn-margo-action" (click)="editNewAssignData()">Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
